import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid /* , Typography */ } from '@material-ui/core'
import { AccessTime, CalendarToday } from '@material-ui/icons'
import LargeIconButton from 'components/theme/LargeIconButton'
import { changeAutomationType } from 'actions/tasks'
import FunnelIcon from 'components/theme/FunnelIcon'

const AutomationTypeButton = connect(
	(state) => ({
		automationTypeSelected: state.tasks.addOrEdit.automationTypeSelected,
	}),
	(dispatch) => bindActionCreators({ changeAutomationType }, dispatch),
)(
	({
		automationTypeSelected,
		automationType,
		Icon,
		changeAutomationType,
		title,
		disabled,
	}) => (
		<LargeIconButton
			onClick={() => changeAutomationType(automationType)}
			variant={
				automationTypeSelected === automationType ? 'contained' : 'outlined'
			}
			Icon={Icon}
			disabled={disabled}
		>
			{title}
		</LargeIconButton>
	),
)

export default connect((state) => {
	const taskID = state.tasks.addOrEdit.taskID
	const task = state.tasks.tasksByID[taskID]
	const stats = task?.sms_stats || task?.email_stats
	const campaignStatus =
		state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
	const taskModalOpen = state.campaign.addOrEdit.taskModalOpen
	const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
	const disabled = Boolean(
		(taskModalOpen && taskID === 'new') ||
			stats ||
			campaignStatus === 'L' ||
			campaignStatus === 'C',
	)

	return {
		disabled,
		automationTypeSelected,
		campaignSelected: state.tasks.addOrEdit.campaignSelected,
		stageSelected: state.tasks.addOrEdit.stageSelected,
	}
}, null)(
	({ disabled, automationTypeSelected, campaignSelected, stageSelected }) => {
		const typesToLabels = {
			scheduled: <div>This task is scheduled.</div>,
			stage: (
				<div>
					This task is part of the{' '}
					<strong>{campaignSelected?.label || 'campaign'}</strong> campaign's{' '}
					<strong>{stageSelected?.label || 'stage'}</strong> funnel stage.
				</div>
			),
			calendar: (
				<div>
					This task is part of the{' '}
					<strong>{campaignSelected?.label || 'campaign'}</strong> campaign
					calendar.
				</div>
			),
		}

		return disabled ? (
			<div>{typesToLabels[automationTypeSelected]}</div>
		) : (
			<Grid container spacing={16}>
				{[
					[AccessTime, 'scheduled', 'Schedule this task'],
					[CalendarToday, 'calendar', 'Add to campaign calendar'],
					[FunnelIcon, 'stage', 'Add to campaign funnel stage'],
				].map((automationType) => (
					<Grid key={`automationTypeButton${automationType[1]}`} item xs={4}>
						<AutomationTypeButton
							disabled={disabled}
							automationType={automationType[1]}
							title={automationType[2]}
							Icon={automationType[0]}
						/>
					</Grid>
				))}
			</Grid>
		)
	},
)
